import React, { memo, useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import {
  Panel,
  PanelHeader,
  PanelBody,
} from "../../components/panel/panel.jsx";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Alert,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import {
  ViewPayment,
  clearPaymentDetails,
  GetAllPayment,
  GetRecentPayments
} from "../../redux/actions/payments";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import PaymentForm from "./paymentForm.jsx";
import moment from "moment";
import SweetAlert from "react-bootstrap-sweetalert";
import { useTranslation } from "react-i18next";
import ReactPaginate from 'react-paginate';


const PaymentsList = memo(
  ({
    payments = [],
    totalPayments,
    GetAllPayment,
    GetRecentPayments,
    user,
    paymentDetail,
    ViewPayment,
    clearPaymentDetails,
    Leases,
    appLoading
  }) => {
    const [loading, setLoading] = useState(false);
    const [modalBody, setModalBody] = useState("");
    const [headerTitle, setHeaderTitle] = useState("");
    const [modalDialog, setModalDialog] = useState(false);
    const [download, setDownload] = useState(false);
    const [isCompleted, setIsCompleted] = useState(false);
    const [isFailed, setIsFailed] = useState(false);
    const [openPaymentAlert, setOpenPaymentAlert] = useState(false);
    const [transactionResponse, setTransactionResponse] = useState("");
    const [selectedPayment, setSelectedPayment] = useState(null);
    const [detailModalOpen, setDetailModalOpen] = useState(false);
    const [activeDetailTab, setActiveDetailTab] = useState("tenders");
    const myRef = useRef();
    const {t} = useTranslation();
    const [page, setPage] = useState(0);
    const [pageCount, setPageCount] = useState(0);

    const openDetailModal = (item) => {
      setSelectedPayment(item);
      setActiveDetailTab("tenders");
      setDetailModalOpen(true);
    };

    const closeDetailModal = () => {
      setDetailModalOpen(false);
      setSelectedPayment(null);
    };

    useEffect(() => {
      if (!payments.length && Leases && Leases.length) {
        GetAllPayment(onSuccess,page+1);
        setLoading(true);
      }
    }, []);

    useEffect(() => {
      if (totalPayments) {
        // — old MongoDB server: Math.ceil(payments[0].totalCount / 20)
        setPageCount(Math.ceil(totalPayments / 20));
      }
    }, [totalPayments]);


    const onSuccess = () => {
      setLoading(false);
    };

    const toggleModal = (value) => {
      // e && e.stopPropagation();
      if (value) {
        setModalBody(value);
      }
      setModalDialog(!modalDialog);
    };

    const closeModal = (bool) => {
      if (bool) {
        GetAllPayment(()=>{}, page? page+1 : 1);
        GetRecentPayments(() => {});
      }
      setModalDialog(false);
    };

    useEffect(() => {
      if (paymentDetail.pdfData && download) {
        myRef.current.click();
      }
    }, [paymentDetail]);

    const handlePdfDownload = (id) => {
      clearPaymentDetails();
      ViewPayment(id, `email=${user.Email_01}`);
      setDownload(true);
    };

    // function to toggle payment alert closing
    const togglePaymentAlert = () => {
      setOpenPaymentAlert(false);
    };

    const handlePageClick = (e) =>{
      setPage(e.selected);
      GetAllPayment(onSuccess,e.selected+1);
    }

    return (
      <div>
        {openPaymentAlert ? (
          isFailed ? (
            <SweetAlert
              error
              confirmBtnText={t('sweetalert.okay')}
              confirmBtnBsStyle="error"
              cancelBtnBsStyle="default"
              title={t('sweetalert.failed')}
              onConfirm={() => togglePaymentAlert()}
            >
              {transactionResponse}
            </SweetAlert>
          ) : (
            <SweetAlert
              success
              confirmBtnText={t('sweetalert.okay')}
              confirmBtnBsStyle="success"
              cancelBtnBsStyle="default"
              title={t('sweetlert.success')}
              onConfirm={() => togglePaymentAlert()}
            >
              Your payment has been processed.
              {/* {transactionResponse} */}
            </SweetAlert>
          )
        ) : (
          ""
        )}
        <div className="d-none">
          <a
            download={paymentDetail?.fileName || "PaymentDataReport.pdf"}
            href={"data:application/pdf;base64," + paymentDetail?.pdfData}
          >
            <i className="fa fa-download" ref={myRef} />
          </a>
        </div>

        {user &&
        user.leaseDetails && user?.leaseDetails?.EvictionStopBoolean ? (
          <div className="row mb-2">
            <div className="col-12">
              <Alert color="pink" className="m-b-10">
                  {t('dashboard.eviction_stop_alert')}
                 </Alert>
            </div>
          </div>
        ) : null}

        <Modal isOpen={modalDialog} toggle={() => toggleModal()}>
          <ModalHeader toggle={() => closeModal()}>
            {headerTitle || "Ania Management"}
          </ModalHeader>
          <ModalBody>
            {modalBody === "payment" && (
              <PaymentForm
                closeModal={closeModal}
                setIsCompleted={setIsCompleted}
                setIsFailed={setIsFailed}
                setOpenPaymentAlert={setOpenPaymentAlert}
                setTransactionResponse={setTransactionResponse}
              />
            )}

          </ModalBody>
        </Modal>
        <Panel>
          <PanelHeader noButton={true}>
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <div className="stats-title text-uppercase text-white font-weight-bold">
                  {t('card-title.payments')}
                </div>
                <div className="stats-desc">
                  {t('card-subtitle.payments')}
                  </div>
              </div>
              {
                    appLoading ? <i className="fas fa-spinner fa-pulse"></i> : null
                  }
              {
              user 
              && user.leaseDetails
              && user.leaseDetails["Lease_PROP::Address_Address01_finalDisplay"]
              && user.leaseDetails["Lease_PROP::Address_City"]
              && user.leaseDetails["Lease_PROP::Address_State"]
              && user.leaseDetails["Lease_PROP::Address_PostalCode"]
              && !user.leaseDetails.EvictionStopBoolean 
              && Leases 
              && Leases.length>0
              &&(
                <UncontrolledDropdown className="pull-right">
                  <DropdownToggle caret className="btn btn-warning">
                    {t('payment-card-button.make-payment')}
                  </DropdownToggle>
                  <DropdownMenu>
                    <>
                      <DropdownItem
                        onClick={() => {
                          if (!loading) {
                            toggleModal("payment");
                            setHeaderTitle(t('modal.payment.header'));
                          }
                        }}
                      >
                        {/* Credit Card Payment */}
                    {t('payment-card-button.credit-card')}
                      </DropdownItem>
                    </>
                  </DropdownMenu>
                </UncontrolledDropdown>
              )}
            </div>
          </PanelHeader>
          <PanelBody>
            <div className="table-responsive">
              <table className="table table-hover">
                <thead>
                  <tr>
                    <th className="text-nowrap">{t('card-table.payment.date')}</th>
                    <th className="text-nowrap text-right">{t('card-table.payment.rent-amount')}</th>
                    <th className="text-nowrap">Notes</th>
                    <th className="text-nowrap">Status</th>
                    <th className="text-nowrap">{t('card-table.payment.receipt')}</th>
                  </tr>
                </thead>
                <tbody>
                  {payments &&
                    payments.map((item, i) => (
                      <tr
                        key={i}
                        className={`text-nowrap ${
                          !item.isApproved && "text-muted font-italic"
                        }`}
                        style={{ cursor: "pointer" }}
                        onClick={() => openDetailModal(item)}
                      >
                        <td>
                          {item.zzCreatedDate ? moment(item.zzCreatedDate).format("MM/DD/YYYY") : "-"}
                        </td>
                        <td className="text-right">
                          <strong>
                            ${item.TotalLEDG
                              ? parseFloat(item.TotalLEDG).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                              : "-"}
                          </strong>
                        </td>
                        <td style={{ whiteSpace: "normal", maxWidth: "400px" }}>
                          {item.Note || "-"}
                        </td>
                        <td>
                          {item.isApproved ? "Approved" : "Pending"}
                        </td>
                        <td>
                          <button
                            className="btn btn-info btn-xs"
                            onClick={(e) => {
                              e.stopPropagation();
                              handlePdfDownload(item.zzID);
                            }}
                          >
                            PDF
                          </button>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </PanelBody>

          {/* Payment Detail Modal */}
          <Modal isOpen={detailModalOpen} toggle={closeDetailModal}>
            <ModalHeader toggle={closeDetailModal}>
              Payment details
            </ModalHeader>
            <ModalBody>
              <Nav tabs>
                <NavItem style={{ flex: 1, textAlign: "center" }}>
                  <NavLink
                    className={activeDetailTab === "tenders" ? "active" : ""}
                    onClick={() => setActiveDetailTab("tenders")}
                    style={{ cursor: "pointer" }}
                  >
                    Tenders
                  </NavLink>
                </NavItem>
                <NavItem style={{ flex: 1, textAlign: "center" }}>
                  <NavLink
                    className={activeDetailTab === "allocations" ? "active" : ""}
                    onClick={() => setActiveDetailTab("allocations")}
                    style={{ cursor: "pointer" }}
                  >
                    Allocations
                  </NavLink>
                </NavItem>
              </Nav>
              <TabContent activeTab={activeDetailTab} className="pt-3">
                <TabPane tabId="tenders">
                  {selectedPayment && (
                    <div className="table-responsive">
                      <table className="table table-sm">
                        <thead>
                          <tr>
                            <th className="text-uppercase text-muted" style={{ fontSize: "11px", fontWeight: 600, letterSpacing: "0.5px" }}>Payment Method</th>
                            <th className="text-uppercase text-muted" style={{ fontSize: "11px", fontWeight: 600, letterSpacing: "0.5px" }}>Last Four</th>
                            <th className="text-uppercase text-muted text-right" style={{ fontSize: "11px", fontWeight: 600, letterSpacing: "0.5px" }}>Amount</th>
                            <th className="text-uppercase text-muted text-right" style={{ fontSize: "11px", fontWeight: 600, letterSpacing: "0.5px" }}>Fee</th>
                            <th className="text-uppercase text-muted text-right" style={{ fontSize: "11px", fontWeight: 600, letterSpacing: "0.5px" }}>Charged</th>
                          </tr>
                        </thead>
                        <tbody>
                          {(selectedPayment.tenders || []).map((tender, ti) => (
                            <tr key={ti}>
                              <td>{tender.paymentMethod}</td>
                              <td>{tender.lastFour}</td>
                              <td className="text-right">${tender.amount}</td>
                              <td className="text-right">{parseFloat(tender.fee) > 0 ? `$${tender.fee}` : ""}</td>
                              <td className="text-right">${tender.charged}</td>
                            </tr>
                          ))}
                          <tr style={{ backgroundColor: "#eef5f9" }}>
                            <td colSpan="4" className="text-right"><strong>Grand total:</strong></td>
                            <td className="text-right">
                              <strong>${selectedPayment.totalChargedAmount
                                ? parseFloat(selectedPayment.totalChargedAmount).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                : "0.00"}</strong>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  )}
                </TabPane>
                <TabPane tabId="allocations">
                  {selectedPayment && (
                    <div className="table-responsive">
                      <table className="table table-sm">
                        <thead>
                          <tr>
                            <th className="text-uppercase text-muted" style={{ fontSize: "11px", fontWeight: 600, letterSpacing: "0.5px" }}>Month</th>
                            <th className="text-uppercase text-muted" style={{ fontSize: "11px", fontWeight: 600, letterSpacing: "0.5px" }}>Sub Category</th>
                            <th className="text-uppercase text-muted text-right" style={{ fontSize: "11px", fontWeight: 600, letterSpacing: "0.5px" }}>Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          {(selectedPayment.allocations || []).map((alloc, ai) => (
                            <tr key={ai}>
                              <td>{alloc.month || "-"}</td>
                              <td>{alloc.subCategory || "-"}</td>
                              <td className="text-right">${alloc.amount
                                ? parseFloat(alloc.amount).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                : "0.00"}</td>
                            </tr>
                          ))}
                          {!(selectedPayment.allocations || []).length && (
                            <tr>
                              <td colSpan="3" className="text-center text-muted">No allocations available</td>
                            </tr>
                          )}
                          {(selectedPayment.allocations || []).length > 0 && (
                            <tr style={{ backgroundColor: "#eef5f9" }}>
                              <td></td>
                              <td><strong>Grand total</strong></td>
                              <td className="text-right">
                                <strong>${(selectedPayment.allocations || [])
                                  .reduce((sum, a) => sum + (parseFloat(a.amount) || 0), 0)
                                  .toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</strong>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  )}
                </TabPane>
              </TabContent>
            </ModalBody>
          </Modal>
        </Panel>
        {
        pageCount ?
      
      <ReactPaginate
          previousLabel={<i className="fas fa-angle-double-left" />}
          nextLabel={<i className="fas fa-angle-double-right" />}
          breakLabel={'...'}
          breakClassName={'break-me'}
          pageCount={pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={5}
          onPageChange={handlePageClick}
          containerClassName={'pagination'}
          activeClassName={'active'}
        />:null}
      </div>
    );
  }
);

const mapStateToProps = ({
  USER_REDUCER,
  PAYMENT_REDUCER,
  LOADING_REDUCER
}) => {
  return {
    payments: PAYMENT_REDUCER.payments,
    totalPayments: PAYMENT_REDUCER.totalPayments,
    user: USER_REDUCER.userData,
    paymentDetail: PAYMENT_REDUCER.paymentDetail,
    Leases: USER_REDUCER.AllLeases,
    appLoading: LOADING_REDUCER.appLoading
  };
};

export default connect(mapStateToProps, {
  ViewPayment,
  clearPaymentDetails,
  GetAllPayment,
  GetRecentPayments
})(PaymentsList);
